import { render, staticRenderFns } from "./AMaintainUser.vue?vue&type=template&id=2473bdce&scoped=true"
import script from "./AMaintainUser.vue?vue&type=script&lang=js"
export * from "./AMaintainUser.vue?vue&type=script&lang=js"
import style0 from "./AMaintainUser.vue?vue&type=style&index=0&id=2473bdce&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2473bdce",
  null
  
)

export default component.exports